import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import codefileReducer from './codefile';
import workTypesReducer from './worktypes';
import queueSettingReducer from './queuesetting';
import batchProcessingReducer from './batchprocessing';
import myQueueReducer from './myqueue';
import queueSearchReducer from './queuesearch';
import workItemSearchReducer from './workitemsearch';
import dashboardReducer from './dashboard';

export default combineReducers({
  global: globalReducer,
  codefile: codefileReducer,
  workTypes: workTypesReducer,
  queueSetting: queueSettingReducer,
  batchProcessing: batchProcessingReducer,
  myQueue: myQueueReducer,
  queueSearch: queueSearchReducer,
  workItemSearch: workItemSearchReducer,
  dashboard: dashboardReducer,
});
